import { Component } from 'react'
import _ from 'lodash'

import PropTypes from 'prop-types'
import cx from 'classnames'
import { Button, SpecAdditionalTips, PopoverImg } from '@vzmi/shp_shared_compo'
import styles from './index.css'
import {
  FormRow,
  CheckboxMenuSelectField,
  InputField,
  TextareaField,
  InputCountField,
  FormLabel,
  RadioGroupInputField,
  MenuSelectField,
  When
} from '../../../../../Common/Form'
import { ATTRIBUTE_CONSTRAINTS_TYPE, ATTRIBUTE_DISPLAY_MODE_TYPES } from '../../../../../../constants/proposalTypes'
import { Field } from '../../../../../Common/forms'
import { getUuid } from '../../../../../../../lib/renderUtil'
import SingleLineText from '../../../../Common/ReadOnlyComponents/SingleLineText/SingleLineText'
import { IconPopoverLabel } from '../../../../Common/ProposalForm/FormLabelTooltip/FormLabelTooltip'
import { required } from '../../../../../../lib/FormHelper'
import { filterHtmlTag, filterHtmlTagAndSpace, bsmiNormalizer } from '../../../../Common/ProposalForm/Shared/normalizers'
import {
  skipRequiredThenValidate,
  textAttributeValidation
} from '../../../../Common/ProposalForm/Shared/validation/validations'
import {
  getCustomAttrItemValidation
} from '../../../../Common/ProposalForm/Shared/validation/fieldLevelValidator'
import Tip from '../../../../Common/Tip'
import { customAttributeInputLengthFormatter } from '../../../../Common/ProposalForm/Shared/formatters'
import { makeItemOptions, getIsBSMIName } from '../../../../Common/ProposalForm/Shared/util'
import ParagraphText from '../../../../Common/ReadOnlyComponents/ParagraphText/ParagraphText'
import { removeInvalidStartEnd } from '../../../../../../lib/parser'
import BSMIIconPopoverLabel from '../../../../Common/BSMIIconPopoverLabel'
import { CDN } from '@vzmi/shp_shared_compo/dist/constants/cdn.js'

const validateAttrItem = (isRequired, msg) => isRequired
  ? skipRequiredThenValidate(required({ msg }))
  : () => { }

class SpecList extends Component {
  renderCustomFieldItem = (attr, attrFieldName, fieldIndex) => {
    const {
      readOnly,
      showErrorOnActive,
      mustShowFormError
    } = this.props
    return (
      <>
        <div
          key={attrFieldName}
          className={styles.customSpecInputName}
          data-role='custom-spec-name'
        >
          <Field
            name={`${attrFieldName}.name`}
            placeholder='請輸入規格標題'
            normalizeOnBlur={filterHtmlTagAndSpace}
            validate={getCustomAttrItemValidation('name', attrFieldName, fieldIndex)}
            format={customAttributeInputLengthFormatter}
            disabled={readOnly}
            component={
              readOnly
                ? ParagraphText
                : InputField
            }
            showErrorOnActive={showErrorOnActive}
            mustShowFormError={mustShowFormError}
          />
        </div>
        <div
          key='value'
          className={styles.customSpecInputValues}
          data-role='custom-spec-value'
        >
          <Field
            name={`${attrFieldName}.values`}
            placeholder='輸入規格內容'
            rows={2}
            validate={getCustomAttrItemValidation('values', attrFieldName)}
            disabled={readOnly}
            normalizeOnBlur={
              _.flow([
                filterHtmlTag,
                removeInvalidStartEnd
              ])
            }
            component={TextareaField}
          />
          <When
            value={!readOnly}
            isTrue
          >
            <Button
              key='deleteButton'
              link
              data-role='delete-button'
              size='medium'
              className={styles.deleteButton}
              onClick={() => attr.remove(fieldIndex)}
              iconType='delete'
            />
          </When>
        </div>
      </>
    )
  }

  renderFieldItem = (fields, attrFieldName, fieldIndex, readOnly) => {
    const {
      showErrorOnActive,
      mustShowFormError
    } = this.props
    const attr = fields.get(fieldIndex)
    const fieldName = `${attrFieldName}.values`
    const {
      hasOTHER,
      name,
      searchable = false,
      required: isRequired,
      options,
      constraints = {}
    } = attr

    const {
      type,
      maximum,
      minimum = 1
    } = constraints

    const {
      RADIOBOX,
      CHECKBOX,
      TEXT
    } = ATTRIBUTE_CONSTRAINTS_TYPE

    let renderAttributeItemField = null

    switch (type) {
      case RADIOBOX: {
        /**
         * 非必填的選單，
         * 需要有一個 value 是 null 的選項讓 user 選擇，
         * 將該 attr 設回空值
         */
        if (!isRequired) {
          const hasNullOption = _.some(options, { value: null })
          if (!hasNullOption) {
            options.push({
              label: '(清除內容)',
              value: null
            })
          }
        }

        renderAttributeItemField = (
          <Field
            closeOnSelect
            closeOnCustomInputSubmit
            editableCustomInput
            multipleCustomInput={false}
            options={options}
            name={fieldName}
            placeholder={`選擇${name}`}
            disabled={readOnly}
            component={MenuSelectField}
            enableCustomInput={hasOTHER}
            normalizeCustomInput={filterHtmlTag}
            menuInputPlaceholder='搜尋關鍵字'
            customInputPlaceholder='請輸入屬性'
            customInputButtonText='自訂其他屬性'
            validate={validateAttrItem(isRequired, `請選擇${name}`)}
            customInputEditingInfo={<Tip type='info'>提醒：使用選單中的預設項目有助於搜尋</Tip>}
            className={cx(styles.attributeItemInput, styles.attributeItemSelect)}
            popupClassName={cx(styles.attributeItemInput, styles.attributeItemSelectPopup)}
            showErrorOnActive={showErrorOnActive}
            mustShowFormError={mustShowFormError}
          />
        )
        break
      }
      case CHECKBOX: {
        // remap item options here for it might carries `displayName` that needs to replace `value` field
        const constraintMsg = `選擇${name}`
        const checkboxOptions = makeItemOptions(options)
        renderAttributeItemField = (
          <Field
            name={fieldName}
            placeholder={constraintMsg}
            disabled={readOnly}
            component={CheckboxMenuSelectField}
            menuInputPlaceholder='搜尋關鍵字'
            validate={[validateAttrItem(isRequired, `請${constraintMsg}`)]}
            multipleCustomInput={false}
            enableCustomInput={hasOTHER}
            editableCustomInput
            normalizeCustomInput={filterHtmlTag}
            customInputPlaceholder='請輸入屬性'
            customInputButtonText='自訂其他屬性'
            customInputEditingInfo={<Tip type='info'>提醒：使用選單中的預設項目有助於搜尋</Tip>}
            options={checkboxOptions}
            showErrorOnActive={showErrorOnActive}
            mustShowFormError={mustShowFormError}
            closeOnSelect
            closeOnCustomInputSubmit
          />
        )
        break
      }
      case TEXT:
      default: {
        const constraintMsg = `輸入${name}`
        const textValidations = skipRequiredThenValidate(
          validateAttrItem(isRequired, `請${constraintMsg}`),
          textAttributeValidation({ required: isRequired, min: minimum, max: maximum })
        )
        renderAttributeItemField = (
          <>
            <div className={styles.fixedWidth}>
              <Field
                name={fieldName}
                className={styles.attributeItemInput}
                normalizeOnBlur={getIsBSMIName(name)
                  ? bsmiNormalizer
                  : filterHtmlTagAndSpace}
                placeholder={constraintMsg}
                validate={textValidations}
                countLimit={maximum || 0}
                component={readOnly ? SingleLineText : InputCountField}
                showErrorOnActive={showErrorOnActive}
                mustShowFormError={mustShowFormError}
              />
            </div>
            <SpecAdditionalTips labelName={name} />
          </>
        )
        break
      }
    }

    const isBSMIName = getIsBSMIName(name)
    const convertedName = isBSMIName
      ? (
        <BSMIIconPopoverLabel>
          {name}
        </BSMIIconPopoverLabel>
      )
      : name

    return renderAttributeItemField && (
      <FormRow
        key={getUuid(fieldName + name + fieldIndex)}
        data-role='spec-list-attr-item'
        data-attr-name={name}
        subTitle={isRequired ? null : '(非必填)'}
        label={convertedName}
        contentClassName={styles.valuesPatchFlexOrder}
      >
        {
          <>
            {renderAttributeItemField}
            <When
              value={searchable}
              isTrue
            >
              <div className={styles.info}>
                <p>(可供搜尋)</p>
              </div>
            </When>
          </>
        }
      </FormRow>
    )
  }

  renderCustomSpecButton = () => {
    const { transientFieldReady, specLevelUndefined, fields } = this.props
    const isCustomSpecButtonDisabled = specLevelUndefined || !transientFieldReady
    return (
      <Button
        data-role='custom-spec-button'
        disabled={isCustomSpecButtonDisabled}
        link
        size='medium'
        iconType='add-attachments'
        className={styles.linkButton}
        onClick={() => fields.push({ constraints: { type: ATTRIBUTE_CONSTRAINTS_TYPE.CUSTOM } })}
      >
        自訂規格
      </Button>
    )
  }

  renderFieldList = () => {
    const {
      fields = [], // `fields` is a "pseudo-array" from Redux-form, @see https://redux-form.com/8.2.2/docs/api/fieldarray.md/#props
      readOnly
    } = this.props

    /**
     * 依據 'constraints.type',
     * 把 fields 分成 clusterAttrFields 跟 customAttrFields
     *
     * clusterAttrFields: 規格表規格 field
     * customAttrFields: 自訂規格 field
     */
    const clusterAttrFields = []
    const customAttrFields = []
    fields.forEach((attrFieldName, fieldIndex) => {
      const attr = fields.get(fieldIndex) // `fields.get(index)` @see https://redux-form.com/8.2.2/docs/api/fieldarray.md/#-code-fields-get-index-function-code-
      const isCustomAttr = _.get(attr, 'constraints.type', '') === ATTRIBUTE_CONSTRAINTS_TYPE.CUSTOM

      const targetAttrList = isCustomAttr ? customAttrFields : clusterAttrFields
      targetAttrList.push({
        attrFieldName,
        fieldIndex
      })
    })

    const isEmptyCustomAttrFields = _.isEmpty(customAttrFields)

    return (
      <>
        {/* 規格清單 */}
        {
          clusterAttrFields.map(
            clusterAttrField => {
              const {
                attrFieldName,
                fieldIndex
              } = clusterAttrField

              return this.renderFieldItem(
                fields,
                attrFieldName,
                fieldIndex,
                readOnly
              )
            })
        }
        {/*  外層，➕ 自訂規格 按鈕 */}
        <When
          value={!readOnly && isEmptyCustomAttrFields}
          isTrue
        >
          <FormRow
            key='customSpec'
            className={styles.customSpecRow}
            label={<FormLabel>{this.renderCustomSpecButton()}</FormLabel>}
          />
        </When>
        <When
          value={!isEmptyCustomAttrFields}
          isTrue
        >
          <FormRow
            key='customFieldsRow'
            data-role='custom-spec-list'
          >
            <div className={styles.customFieldsWrap}>
              {customAttrFields.map(
                (customFieldDef) => {
                  const { attrFieldName, fieldIndex } = customFieldDef
                  return (
                    <FormRow
                      key={attrFieldName + fieldIndex}
                      noLabel
                      className={styles.customFieldsWrapItem}
                    >
                      {this.renderCustomFieldItem(fields, attrFieldName, fieldIndex)}
                    </FormRow>
                  )
                })
              }
              {/* 內層，➕ 自訂規格 按鈕 */}
              <When
                value={!readOnly}
                isTrue
              >
                <div className={styles.customButtonWrap}>
                  {this.renderCustomSpecButton()}
                </div>
              </When>
            </div>
          </FormRow>
        </When>
      </>
    )
  }

  render () {
    const {
      className,
      readOnly
    } = this.props

    return (
      <div
        className={cx(styles.SpecList, className)}
        data-role='spec-list'
      >
        {/* 商品規格 表格式 條列式 */}
        <FormRow
          labelAlign='top'
          label={(
            <IconPopoverLabel
              popoverContent={(
                <PopoverImg
                  url={`${CDN}/img/tooltip_attributes.png`}
                  width={500}
                  height={610}
                />
              )}
            >
              商品規格
            </IconPopoverLabel>
          )}
        >
          <Field
            name='product.attributeDisplayMode'
            data-role='attribute-display-mode-radio'
            className={styles.attributeDisplayModeRadio}
            component={RadioGroupInputField}
            disabled={readOnly}
            options={ATTRIBUTE_DISPLAY_MODE_TYPES}
          />
        </FormRow>
        {/* 商品規格 清單 */}
        {this.renderFieldList()}

      </div>
    )
  }
}

SpecList.propTypes = {
  className: PropTypes.string,
  transientFieldReady: PropTypes.bool,
  specLevelUndefined: PropTypes.bool,
  fields: PropTypes.object
}

export default SpecList
